export const onIdle = (map) => new Promise((resolve) => {
  google.maps.event.addListenerOnce(map, 'idle', () => {
    resolve();
  });
});

export const isMarkerVisibleOnMap = (marker, mapBounds) => (
  mapBounds ? mapBounds.contains(marker.position) : false
);

export const filterMarkersByView = (map, markers, mapBounds) => {
  const zoom = map.getZoom();

  return zoom > 10 ?
    markers.filter(marker => isMarkerVisibleOnMap(marker, mapBounds)) :
    [];
}

export const findMarkerById = (id, markers) => markers.find(el => el.info['@id'] === id);

export const arrayToLatLng = (arr) => Object.fromEntries(arr.map((el, i) => [i === 0 ? 'lat' : 'lng', el]))
